var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurrency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 118,
    viewBox: "0 0 393 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.44 42.1037L0 67.5585V98C0 109.046 8.9543 118 20 118H363C379.569 118 393 104.569 393 88V22.0282C391.568 21.335 389.483 21.1035 388.598 21.0492C381.707 20.6267 377.754 24.6567 372.25 28.3919L372.181 28.4384C370.554 29.5435 366.484 32.3081 359.045 32.3081C351.499 32.3081 346.259 29.6973 344.582 28.3919L319.43 7.83226C316.077 5.22151 308.741 0 300.566 0C292.392 0 285.894 5.22151 282.96 7.83226L166.632 95.461C164.746 97.0927 158.961 100.356 150.912 100.356C142.863 100.356 137.078 97.0927 135.192 95.461L67.9104 39.6561C65.6048 37.6981 58.8557 33.7819 50.304 33.7819C41.7523 33.7819 34.1648 39.3298 31.44 42.1037Z",
    fill: "url(#paint0_linear_4_436)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_436",
    x1: 196.5,
    y1: -8.80597,
    x2: 196.5,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/Currency.2965f3691046b64b7ba2e0a0528b27fd.svg";
export { ForwardRef as ReactComponent };